import AdminClientDashboard from '../../components/client_dashboard/admin_client_dashboard';
import { ClientObject } from '../../params/redux/client';
import CustomerDashboard from '../../components/client_dashboard/customer_dashoard';
import { fetchClientDetailThunk } from '../../redux/thunks/client';
import { fetchClientsCustomerThunk } from '../../redux/thunks/customer';
import { fetchDueTasksListThunk } from '../../redux/thunks/task';
import { fetchRecentFilesThunk } from '../../redux/thunks/file';
import { Overlay } from '../../components/prospecting';
import { useEffect } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

const ClientDashboardPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { loaders } = useSelector((state: RootState) => state.client);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { clients } = useSelector((state: RootState) => state.client);

    useEffect(() => {
        const fetchClientDetail = async () => {
            try {
                if (id && currentUser?.role === 'client' && parseInt(id, 10) === currentUser.client_id) {
                    await Promise.all([
                        dispatch(fetchClientDetailThunk(parseInt(id, 10))).unwrap(),
                        dispatch(fetchDueTasksListThunk(id ? parseInt(id as string, 10) : 0)).unwrap(),
                        dispatch(fetchRecentFilesThunk(id ? parseInt(id as string, 10) : 0)).unwrap()
                    ]);
                    await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                } else if (id && currentUser?.role !== 'client') {
                    if (!clients || clients.length === 0) return;
                    // await dispatch(fetchAllClientsThunk()).unwrap();
                    const checkExistOrNot = clients.find((item: ClientObject) => item?.id === parseInt(id || '0', 10));
                    if (checkExistOrNot) {
                        await Promise.all([
                            dispatch(fetchClientDetailThunk(parseInt(id, 10))).unwrap(),
                            dispatch(fetchDueTasksListThunk(id ? parseInt(id as string, 10) : 0)).unwrap(),
                            dispatch(fetchRecentFilesThunk(id ? parseInt(id as string, 10) : 0)).unwrap()
                        ]);
                        await dispatch(fetchClientsCustomerThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                    } else {
                        navigate(`/app/client/${clients[0].id}/dashboard`);
                    }
                } else {
                    navigate(`/app/client/${currentUser?.client_id}/dashboard`);
                }
            } catch (e) {
                // Catch errors
            }
        };
        fetchClientDetail();
    }, [id, clients, dispatch, navigate, currentUser?.role, currentUser?.client_id]);

    if (loaders.isLoading) {
        return <Overlay>
            <CircularProgress size={24} />
            <Typography ml={2}>Loading...</Typography>
        </Overlay>;
    }
    if (currentUser?.role !== 'client') {
        return <AdminClientDashboard />;
    }
    return <CustomerDashboard />;
};

export default ClientDashboardPage;